export const CheveronDown = () => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.528199 0.871494C0.653217 0.746514 0.822756 0.676303 0.999532 0.676303C1.17631 0.676303 1.34585 0.746514 1.47087 0.871494L4.99953 4.40016L8.5282 0.871494C8.5897 0.807821 8.66326 0.757032 8.7446 0.722093C8.82593 0.687154 8.91341 0.668763 9.00193 0.667994C9.09045 0.667225 9.17824 0.684093 9.26017 0.717613C9.3421 0.751134 9.41653 0.800636 9.47913 0.863231C9.54172 0.925826 9.59123 1.00026 9.62475 1.08219C9.65827 1.16412 9.67514 1.25191 9.67437 1.34043C9.6736 1.42895 9.65521 1.51643 9.62027 1.59776C9.58533 1.6791 9.53454 1.75266 9.47087 1.81416L5.47087 5.81416C5.34585 5.93914 5.17631 6.00935 4.99953 6.00935C4.82276 6.00935 4.65322 5.93914 4.5282 5.81416L0.528199 1.81416C0.403218 1.68914 0.333008 1.5196 0.333008 1.34283C0.333008 1.16605 0.403218 0.996513 0.528199 0.871494Z"
        fill="#6D6D6D"
      />
    </svg>
  );
};
